import { computed } from '@angular/core';
import { signalStore, withComputed, withMethods } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { filter, pipe, tap } from 'rxjs';
import { withReplicationPool } from './replication-pool.feature';

export const SimulatorSessionReplicationStore = signalStore(
    { providedIn: 'root' },
    withReplicationPool<string>({
        label: 'simulator',
        start: async (sessionId, { getDatabase, signalingUrl }) => {
            const { startSimulatorSessionReplication } = await import('./simulator-session-webrtc-replication');

            return startSimulatorSessionReplication(
                { sessionId, signalingServerUrl: signalingUrl, topic: `custom-spawn-simulator-${sessionId}` },
                getDatabase()
            );
        },
    }),
    withComputed((store) => ({ isHost: computed(() => store.role() === 'host') })),
    withMethods((store) => ({
        host: rxMethod<string | null | undefined>(
            pipe(
                filter((id): id is string => !!id),
                tap((id) => store._connect(id, 'host'))
            )
        ),
        join: rxMethod<string | null | undefined>(
            pipe(
                filter((id): id is string => !!id),
                tap((id) => store._connect(id, 'joiner'))
            )
        ),
    }))
);
